import React from 'react';

export const GmailSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_2230_19058)">
			<path
				d="M7.04545 31.25H11.8182V19.659L5 14.5454V29.2045C5 30.3363 5.91705 31.25 7.04545 31.25Z"
				fill="#4285F4"
			/>
			<path
				d="M28.1818 31.25H32.9546C34.0864 31.25 35 30.3329 35 29.2045V14.5454L28.1818 19.659"
				fill="#34A853"
			/>
			<path
				d="M28.1818 10.7955V19.6591L35 14.5455V11.8182C35 9.28864 32.1125 7.8466 30.0909 9.36364"
				fill="#FBBC04"
			/>
			<path
				d="M11.8182 19.659V10.7954L20 16.9318L28.1818 10.7954V19.659L20 25.7954"
				fill="#EA4335"
			/>
			<path
				d="M5 11.8182V14.5455L11.8182 19.6591V10.7955L9.90909 9.36364C7.88409 7.8466 5 9.28864 5 11.8182Z"
				fill="#C5221F"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2230_19058">
				<rect width="30" height="22.5" fill="white" transform="translate(5 8.75)" />
			</clipPath>
		</defs>
	</svg>
);
